class BMRecommendationRule {
    constructor(rule) {
        this.rule = rule;
    }

    /**
     * By default bm recommendation rule can't be met
     * @returns {null}
     */
    // eslint-disable-next-line class-methods-use-this
    getIsRuleMet() {
        return null;
    }
}

export default BMRecommendationRule;
